var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-overlay",attrs:{"role":"status"}},[(_vm.progress === null)?_c('i',{staticClass:"fa fa-spinner fa-pulse",attrs:{"role":"img","aria-label":"Loading"}}):_c('progress-bar',{staticClass:"progress",attrs:{"progress":_vm.progress}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }